function productIndex(productsList, productId, genreId) {
  let indexList = {
    genreIdIndex: null,
    productIdIndex: null
  };
  let genreIdIndex = productsList.findIndex(({genreId}) => genreId === genreId);
  if(genreIdIndex != -1) {
    indexList.genreIdIndex = genreIdIndex;
  }

  if(indexList.genreIdIndex == null) return;

  let productIdIndex = productsList[genreIdIndex].itemList.findIndex(({product}) => product.productId === productId);
  if(productIdIndex != -1) {
    indexList.productIdIndex = productIdIndex;
  }
  return indexList;
}

function createItemDetail(selectItem, currentMonth, itemCount, current) {
  return {
    childFund: selectItem.product.selectableChildFund,
    currentMonth: currentMonth == selectItem.currentOrderMonth,
    genreId: selectItem.product.genre.genreId,
    orderCount: itemCount,
    orderMonth: current ? selectItem.currentOrderMonth : selectItem.nextOrderMonth,
    orderYear: current ? selectItem.currentOrderYear : selectItem.nextOrderYear,
    price: selectItem.product.price,
    productId: selectItem.product.productId
  }
}

function createPurchaseOrderItemList(selectItem, currentMonth, currentOrderCount, nextOrderCount) {
  let data = {
    currentMonth: currentMonth,
    productId: selectItem.product.productId,
    productName: selectItem.product.productName,
    purchaseOrderItemList: [],
    shipmentFee: 0,
    totalPrice: currentOrderCount * selectItem.product.price + nextOrderCount * selectItem.product.price
  }
  let item1 = createItemDetail(selectItem, currentMonth, currentOrderCount, true);
  if(item1) {
    data.purchaseOrderItemList.push(item1)
  }
  let item2 = createItemDetail(selectItem, currentMonth, nextOrderCount, false);
  console.log(item2);
  if(item2) {
    data.purchaseOrderItemList.push(item2)
  }

  console.log(data);

  return data;
}

function updateItemDetail(selectItem, currentMonth, itemCount, current) {
  let index = 0;
  if(!current) {
    index = 1;
  }
  return {
    childFund: selectItem.purchaseOrderItemList[index].childFund,
    currentMonth: selectItem.purchaseOrderItemList[index].currentMonth,
    genreId: selectItem.purchaseOrderItemList[index].genreId,
    orderCount: itemCount,
    orderMonth: selectItem.purchaseOrderItemList[index].orderMonth,
    orderYear: selectItem.purchaseOrderItemList[index].orderYear,
    price: selectItem.purchaseOrderItemList[index].price,
    productId: selectItem.purchaseOrderItemList[index].productId,
  }
}

function updatePurchaseOrderItemList(selectItem, currentMonth, currentOrderCount, nextOrderCount) {
  let data = {
    currentMonth: currentMonth,
    productId: selectItem.productId,
    productName: selectItem.productName,
    purchaseOrderItemList: [],
    shipmentFee: 0,
    totalPrice: currentOrderCount * selectItem.purchaseOrderItemList[0].price + nextOrderCount * selectItem.purchaseOrderItemList[0].price
  }
  let item1 = updateItemDetail(selectItem, currentMonth, currentOrderCount, true);
  if(item1) {
    data.purchaseOrderItemList.push(item1)
  }
  let item2 = updateItemDetail(selectItem, currentMonth, nextOrderCount, false);
  if(item2) {
    data.purchaseOrderItemList.push(item2)
  }

  return data;
}

function calcPoint(productList, productId, genreId, currentOrderCount, nextOrderCount)  {
  const IndexList = productIndex(productList, productId, genreId);
  const point = productList[IndexList.genreIdIndex].itemList[IndexList.productIdIndex].product.point;
  return point * currentOrderCount + point * nextOrderCount;
}

function deleteOrderZeroItem(data) {
  for (var i = 0; i < data.nselectionOrderList.length; i++) {
    let index = data.nselectionOrderList[i].purchaseOrderItemList.findIndex(({orderCount}) => orderCount == 0);
    if(index == -1) continue;
    data.nselectionOrderList[i].purchaseOrderItemList.splice(index, 1)
  }
  return data;
}

export default {
  productIndex,
  createPurchaseOrderItemList,
  updatePurchaseOrderItemList,
  calcPoint,
  deleteOrderZeroItem
}



// WEBPACK FOOTER //
// ./src/model/n-selection/selectProducts.js